import { Buffer } from 'buffer';

export function authToken() {
    const token = JSON.parse(
        JSON.parse(localStorage.getItem('persist:root')).auth
    ).authToken;

    return token ? `Bearer ${token}` : false;
}
export function payloadUser() {
    const idTokenPayload = JSON.stringify(
        JSON.parse(JSON.parse(localStorage.getItem('persist:root')).auth)
            .idTokenPayload
    );

    const payload = Buffer.from(JSON.stringify(idTokenPayload)).toString(
        'base64'
    );

    // const buff = Buffer.from(payload, 'base64');
    // const text = buff.toString('utf-8');
    // console.log(JSON.parse(text));

    return payload ? `Bearer ${payload}` : false;
}
